import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/PageHeader";
import { SettingsSection } from "@/components/SettingsSection";
import { SettingsRow } from "@/components/SettingsRow";
import { LanguageSelect } from "@/components/LanguageSelect";
import { ThemeSelect } from "@/components/ThemeSelect";
import { ProfileSection } from "@/features/account/components/ProfileSection";
import { PasswordSection } from "@/features/account/components/PasswordSection";
import { DangerZoneSection } from "@/features/account/components/DangerZoneSection";

export function AccountPage() {
  const { t } = useTranslation();

  return (
    <div className="max-w-2xl">
      <PageHeader title={t("account.title")} subtitle={t("account.subtitle")} />
      <ProfileSection />
      <PasswordSection />
      <SettingsSection title={t("settings.appearance.sectionTitle")}>
        <SettingsRow
          label={t("settings.language.label")}
          description={t("settings.language.description")}
        >
          <LanguageSelect />
        </SettingsRow>
        <SettingsRow
          label={t("settings.theme.label")}
          description={t("settings.theme.description")}
        >
          <ThemeSelect />
        </SettingsRow>
      </SettingsSection>
      <DangerZoneSection />
    </div>
  );
}
